import './loader.css';

export const PLoader = () => {
    return (
        <>
            <div className="content">
                <div className="pill">
                    <div className="medicine">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                    </div>
                    <div className="side"></div>
                    <div className="side"></div>
                </div>
            </div>
        </>
    );
};
